/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-09-06 13:06:29
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-06 18:07:24
 */
import React, { ReactNode, useState } from "react";
import {Button, Divider, message, Modal} from "antd";
import styles from "./index.less";
import contactUsQrCode from "@/assets/images/contact-us-qr-code-huanyu.webp";
import { useTranslation } from "react-i18next";
import ModalBg from "@/assets/icons/subscription/bg.svg";
import {cancelPayment, cancelSubscriptionOrder, fetchBillingHistory} from "@/api/modules/plan";
import {getCurrentUser} from "@/api/modules/user";
import {setCurrentUser} from "@/redux/modules/global/action";
import {useDispatch} from "react-redux";

export default function CancelTryUseModal({ open, onCancel ,onSuccess}) {
	const { t } = useTranslation();


	const handleFinish = () => {
		cancelSubscriptionOrder().then((res) => {
			if (res.code === 200) {
				message.success(t("message.success"));
				onSuccess();
			}
		});
	};
	return (
		<>
			<Modal
				width={700}
				open={open}
				cancelText={t("action.button.cancel")}
				okButtonProps={{
					style: { background: "#FF4D4F" }
				}}
				okText={t("billing.blank.button.Confirm Cancellation button")}
				onCancel={() => {
					onCancel();
				}}
				onOk={handleFinish}
				title={t("billing.blank.button.Confirm Cancellation")}
			>
				<Divider />
				<div>
					<div>{t("billing.blank.button.Cancellation.try.title")}</div>
				</div>
			</Modal>
		</>
	);
}
